import type { FeatureMiddleware } from '@cast/api-client';
import {
  demoClusterRuntimeSecurityAnomalies,
  demoClusterRuntimeSecurityAnomaliesOverview,
  demoClusterRuntimeSecurityAnomalyDetails,
  demoClusterRuntimeSecurityAnomalyEvents,
  demoClusterRuntimeSecurityRuleDetails,
  demoClusterRuntimeSecurityRules,
  demoRuntimeSecurityCustomDenyListEntries,
  demoRuntimeSecurityCustomDenyLists,
  demoRuntimeSecurityEvents,
  demoRuntimeSecurityEventsProcessTree,
} from '@cast/fixtures';

import { getIsClusterDemoMode } from '@cast/infrastructure-demo';

import { rejectDemoClusterRequest } from '../utils';

export const runtimeSecurity: FeatureMiddleware<'runtimeSecurity'> = {
  getAnomalies: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterRuntimeSecurityAnomalies();
      return resolve(fixture);
    }
    return next();
  },
  getAnomalyDetails: async ({ args, next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterRuntimeSecurityAnomalyDetails(
        args[0].id
      );
      return resolve(fixture);
    }
    return next();
  },
  getAnomalyEvents: async ({ args, next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterRuntimeSecurityAnomalyEvents(args[0].id);
      return resolve(fixture);
    }
    return next();
  },
  getAnomaliesOverview: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterRuntimeSecurityAnomaliesOverview();
      return resolve(fixture);
    }
    return next();
  },
  getRules: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterRuntimeSecurityRules();
      return resolve(fixture);
    }
    return next();
  },
  getRuleDetails: async ({ args, next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoClusterRuntimeSecurityRuleDetails(args[0].id);
      if (!fixture) {
        return rejectDemoClusterRequest();
      }
      return resolve(fixture);
    }
    return next();
  },
  getRuntimeEvents: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoRuntimeSecurityEvents();
      return resolve(fixture);
    }
    return next();
  },
  getRuntimeEventsProcessTree: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoRuntimeSecurityEventsProcessTree();
      return resolve(fixture);
    }
    return next();
  },
  getCustomDenyLists: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoRuntimeSecurityCustomDenyLists();
      return resolve(fixture);
    }
    return next();
  },
  getCustomDenyListEntries: async ({ next, resolve }) => {
    if (getIsClusterDemoMode()) {
      const fixture = await demoRuntimeSecurityCustomDenyListEntries();
      return resolve(fixture);
    }
    return next();
  },
};
